import React, { useEffect, useState } from "react";
import TableComponent from "../../../layoutComponents/TableComponent";
import CreatePayment from "./CreatePayment";
import { EndPoints } from "../../../utils/EndPoints";
import { apiCall } from "../../../redux/modules/moduleActions";
import {
  Box,
  Tooltip,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress,
} from "@mui/material";
import { MoreHorizOutlined, Edit as EditIcon, DeleteOutline as DeleteIcon } from "@material-ui/icons";
import { disableColor, primary } from "../../../styles/colors";
import { useSnackbar } from "../../../snackbarContext";
const paymentDataHeaders = [
  "Sr.No.",
  "Date",
  "Payment ID",
  "Payment Amount",
  "RTGS",
  "Allocated to Bills",
  "Allocated to Advance",
  "Remark",
];
const getFormattedDate = (dateString) => {
  const date = new Date(dateString);
  const options = { month: "short", day: "numeric", year: "numeric" };
  const formattedDate = date.toLocaleDateString("en-US", options);
  const day = date.getDate();

  const daySuffix =
    day === 1 || day === 21 || day === 31
      ? "st"
      : day === 2 || day === 22
      ? "nd"
      : day === 3 || day === 23
      ? "rd"
      : "th";

  return formattedDate.replace(day, `${day}${daySuffix}`);
};

function MillerPayments({ singlelistView, MillersFunction, userRole }) {
  const [payments, setPayments] = useState({ list: [], advance: 0, count: 0 });
  const [editRowData, setEditRowData] = useState(null);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [deleting, setDeleting] = useState(false);
  const showSnackbar = useSnackbar();
  const fetchPayments = async (millerDetail, nextURL = "") => {
    const getNextBill = EndPoints.millerPayments.getList();
    const res = await apiCall({
      method: "get",
      api: nextURL ? nextURL : `${getNextBill}?miller_id=${millerDetail.id}`,
    });
    setPayments({ list: res.results, ...res });
  };

  useEffect(() => {
    if (singlelistView && singlelistView !== null) {
      fetchPayments(singlelistView);
    }
  }, [singlelistView]);

  const handleConfirmDelete = async () => {
    if (!deleteTarget) return;
    setDeleting(true);
    const res = await apiCall({
      method: "delete",
      api: EndPoints.millerPayments.delete_payment(deleteTarget.id),
    });
    setDeleting(false);
    if (res && res.error) {
      showSnackbar(res.data || "Failed to delete payment", "error");
      return;
    }
    showSnackbar("Payment deleted", "success");
    setDeleteTarget(null);
    if (singlelistView && singlelistView !== null) {
      fetchPayments(singlelistView);
    }
  };

  return (
    <Box>
      <TableComponent
        header={paymentDataHeaders}
        descending={true}
        setSelectedList={(selected) => {
          console.log(selected, "selected=");
          setEditRowData(selected);
        }}
        noAddButton={['broker' , 'miller'].includes(userRole)}
        actions={
          ['broker', 'miller'].includes(userRole)
            ? []
            : [
                { name: "edit", label: "Edit", icon: <EditIcon fontSize="small" /> },
                {
                  name: "delete",
                  label: "Delete",
                  icon: <DeleteIcon fontSize="small" style={{ color: "#dc3545" }} />,
                  onClick: () => setDeleteTarget(editRowData),
                },
              ]
        }
        noAction={{
          ui: (rowData) =>
            Boolean(rowData?.is_bill_advanced)  ? (
              <Tooltip title="Bill Allocated" placement="top">
                <div
                  className="d-flex alignC justifyC"
                  style={{
                    margin: "12px 10px",
                    width: "50px",
                  }}
                >
                  <MoreHorizOutlined style={{ color: disableColor }} />
                </div>
              </Tooltip>
            ) : (
              false
            ),
        }}
        tableList={
          payments.list && payments.list.length > 0
            ? payments.list.map((item, index) => {
                const date = item.payment_date;
                return {
                  ...item,
                  Date: getFormattedDate(date),
                  "Payment ID": item.payment_id,
                  "Payment Amount": `₹ ${Number(
                    item.payment_amount ?? 0
                  ).toFixed(0)}/-`,
                  "Allocated to Bills": `₹ ${item.paid_bills
                    .reduce((sum, bill) => {
                      return sum + parseFloat(bill.allocated_to_bill || 0);
                    }, 0)
                    .toFixed(0)}/-`,
                  "Allocated to Advance": `₹ ${Number(
                    item.allocated_to_advanced ?? 0
                  ).toFixed(0)}/-`,
                  RTGS: item.rtgs_charge,
                  Remark: item.remark,
                };
              })
            : []
        }
        module="Payment"
        customCreateFile={(rest) => {
          return (
            <CreatePayment
              {...rest}
              millerDetail={singlelistView}
              apiCall={MillersFunction}
              onClose={() => {
                setEditRowData(null);
                rest.onClose();
                if (singlelistView && singlelistView !== null) {
                  fetchPayments(singlelistView);
                }
              }}
            />
          );
        }}
        pagination={{
          count: payments.count,
          next: payments.next,
          previous: payments.previous,
          customPagination: true,
          tablePagination: (url) => {
            fetchPayments(singlelistView, url);
          },
        }}
      />

      <Dialog open={Boolean(deleteTarget)} onClose={() => !deleting && setDeleteTarget(null)}>
        <DialogTitle>Delete Payment</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to delete payment {deleteTarget?.payment_id}? This cannot be
            undone.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteTarget(null)} disabled={deleting}>
            Cancel
          </Button>
          <Button
            onClick={handleConfirmDelete}
            disabled={deleting}
            style={{ color: "#dc3545" }}
          >
            {deleting ? <CircularProgress size={18} style={{ color: primary }} /> : "Delete"}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default MillerPayments;
